module.exports = __webpack_public_path__ + "media/images/mmotrade-seo_logo-3190adf565c04ea200fa248a783d7890.jpg";